export const ENTITLEMENT_CONFIG = [
  {
    key: 'seats',
    label: 'Team Seats',
    singularLabel: 'Team Seat',
    type: 'number',
  },
  {
    key: 'entities',
    label: 'Entities',
    singularLabel: 'Entity',
    type: 'number',
  },
  {
    key: 'templates',
    label: 'Pass Templates',
    singularLabel: 'Pass Template',
    type: 'number',
  },
  {
    key: 'passes',
    label: 'Lifetime Passes',
    singularLabel: 'Lifetime Pass',
    type: 'number',
  },
  {
    key: 'readerLogins',
    label: 'PassEntry Reader App logins',
    singularLabel: 'PassEntry Reader App login',
    type: 'number',
  },
  { key: 'localisation', label: 'Multi-language support', type: 'boolean' },
  { key: 'watermark', label: 'Watermark removal', type: 'boolean' },
  { key: 'passBinding', label: 'Pass Binding', type: 'boolean' },
  { key: 'sso', label: 'Single Sign-On (SSO)', type: 'boolean' },
];

export const formatCountWithUnit = (value, label, singularLabel) => {
  if (singularLabel != null && Number(value) === 1) {
    return `1 ${singularLabel}`;
  }
  return `${value?.toLocaleString() ?? 0} ${label}`;
};

export const getEntitlementValue = (entitlements, key) => {
  if (!entitlements) return undefined;
  const value = entitlements[key];
  if (value !== undefined && value !== null) return value;
  if (key === 'readerLogins') {
    return entitlements.reader_logins;
  }
  return value;
};

export const hasEntitlementValue = (entitlements, key, type) => {
  const value = getEntitlementValue(entitlements, key);
  if (type === 'boolean') return value !== undefined && value !== null;
  return value !== undefined && value !== null;
};

export const getFormattedEntitlementValue = (
  entitlements,
  key,
  label,
  singularLabel,
  type
) => {
  const value = getEntitlementValue(entitlements, key);
  if (type === 'boolean') return label;
  return formatCountWithUnit(value, label, singularLabel);
};
